export const ASSETS_URL = process.env.REACT_APP_ASSETS_PATH;
export const IMAGES_URL = `${process.env.REACT_APP_ASSETS_PATH}/images`;
export const ASSETS_COMMONS_URL = `${process.env.REACT_APP_CDN_PATH}/commons`;
export const STRIPE_KEY = process.env.REACT_APP_STRIPE_KEY;
